import React from 'react';

import autoBind from 'react-autobind';
import { If, Then, Else } from 'react-if'
import { CirclePicker } from 'react-color';

// import other components within the same project here
import Config from "composer/Config.jsx";

import Localization from "composer/Localization.jsx"

import CreateContentDialog from "composer/views/content/CreateContentDialog.jsx"
import EditContentDialog from "composer/views/content/EditContentDialog.jsx"
import Docuement from "composer/images/background/docuement.png";

import { Icon, IconButton, Grid, TextField, Tooltip, List, ListItem, ListItemIcon, ListItemText, ListItemSecondaryAction, ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails, Card, CardContent, Select, MenuItem, FormControl, Divider, Slider, Button, Container } from '@material-ui/core';
import {
  grey,
} from '@material-ui/core/colors'

import { DndProvider, Preview, useDrag, useDrop } from 'react-dnd-multi-backend'
import { HTML5Backend } from 'react-dnd-html5-backend'
import { TouchBackend } from 'react-dnd-touch-backend'
import { MouseTransition } from 'react-dnd-multi-backend'
import { createTransition } from 'react-dnd-multi-backend'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import RootRef from "@material-ui/core/RootRef";

const TouchTransition = createTransition('touchstart', (event) => {
  return event.touches != null
})

const getItems = count =>
  Array.from({ length: count }, (v, k) => k).map(k => ({
    id: `item-${k}`,
    primary: `item ${k}`,
    secondary: k % 2 === 0 ? `Whatever for ${k}` : undefined
  }));

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const tempDid = result[startIndex];
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  if(startIndex < endIndex){
    for(let i = startIndex; i < endIndex; i++){
      result[i].display_index--;
      if(i + 1 == endIndex){
        result[i+1].display_index = endIndex;
      }
    }
  }

  if(startIndex > endIndex){
    result[endIndex].display_index = endIndex;
    for(let i = endIndex + 1; i <= startIndex; i++){
      result[i].display_index++;  
    }
  }

  for(let i = 0; i < result.length; i++){
    //console.log("result.id " + result[i].index);
    //console.log("result.display id " + result[i].display_index);
  }
  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // styles we need to apply on draggables
  ...draggableStyle,

  ...(isDragging && {
    background: "rgb(235,235,235)"
  })
});

const getListStyle = isDraggingOver => ({
  //background: isDraggingOver ? 'lightblue' : 'lightgrey',
});


export const HTML5toTouch = {
  backends: [
    {
      id: 'html5',
      backend: HTML5Backend,
      transition: MouseTransition,
    },
    {
      id: 'touch',
      backend: TouchBackend,
      options: {enableMouseEvents: true},
      preview: true,
      transition: TouchTransition,
    },
  ],
}

class HotspotDetailView extends React.Component {
  constructor(props) {
    super(props);
    this.refs = React.createRef();
    this.onDragEnd = this.onDragEnd.bind(this);

    // state variables here
    this.state = {
      contentList: [],
      hotspotName: "",
      hotspotColor: "#3f51b5",
      hotspotRadius: 10,
      hotspotVisibility: 0,
      currentContentIndex: -1,
      contentID: -1,
      contentListHeight: 0,
    };
    autoBind(this);
    let hotspot = this.props.currentHotspot;
    if (this.props.currentHotspot) {
      this.getContentByHotspotID(hotspot['id']);
      this.state.hotspotName = hotspot['name'];
      this.state.hotspotColor = "#" + parseInt(hotspot['color']).toString(16).padStart(6, '0');
      this.state.hotspotRadius = parseFloat(hotspot['radius']);
      this.state.hotspotVisibility = parseInt(hotspot['disclose']);
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    let boundingRect = this.refs.visibilityDiv.getBoundingClientRect();
    let height = window.innerHeight - (boundingRect.y + boundingRect.height);
    height -= 32; // Grid spacing={2} 2*8px = 16px
    this.setState({
      contentListHeight: height,
    });
    this.state.contentListHeight = height;
  }

  getContentTypeCount() {
    return Config.HOTSPOT_CONTENT_TYPE_COUNT - 1;
  }

  getContentByHotspotID(hotspotID) {
    let requestObj = {table: "component",filter: { hotspot_id: hotspotID }};
    this.props.root.refs.API.request("get_list", requestObj, this.getContentOK, this.getContentFail);
  }

  getContentOK(res) {
    let sortedContentList = res.body.result.slice();
    sortedContentList.sort((a, b) => parseInt(a.display_index) - parseInt(b.display_index));
    this.setState({ contentList: sortedContentList });
    this.state.contentList = sortedContentList;

    this.decodeContentPayload();
  }

  getContentFail(err) {
    console.log("get content from server failed");
  }

  decodeContentPayload() {
    let newContentList = this.state.contentList.slice();
    for (let i = 0; i < newContentList.length; i++) {
      try {
        newContentList[i].payload = JSON.parse(newContentList[i].payload);
      }
      catch (err) {
        console.log(err);
      }
    }
    this.setState({ contentList: newContentList });
    this.state.contentList = newContentList;
  }
  
  hotspotNameChanged(e) {
    this.setState({ hotspotName: e.target.value });
    this.state.hotspotName = e.target.value;
  }

  hotspotColorChanged(color, event) {
    this.setState({hotspotColor: color.hex});
    this.state.hotspotColor = color.hex;
    this.props.parent.updateHotspotColor(color);
  }

  hotspotRadiusChanged = (event, value) => {
    this.setState({ hotspotRadius: value });
    this.state.hotspotRadius = value;
  };

  setHotspotRadius() {
    this.props.parent.updateHotspotRadius(this.state.hotspotRadius);
  }

  hotspotVisibilityChanged(e) {
    this.setState({ hotspotVisibility: e.target.value });
    this.state.hotspotVisibility = e.target.value;
  }

  handleAddContentClicked() {
    // console.log('content list length:', this.state.contentList.length);
    // console.log('userinfo role:', this.props.root.refs.userDataProfile.state.userInfo.role);
    //check if content number is more than max 
    var max_len = this.props.root.refs.userDataProfile.state.userInfo.role == 2?Config.MAX_COMPONENET_LEN().PREMIUM:Config.MAX_COMPONENET_LEN().NORMAL;
    // console.log('max len:', max_len);
    if(this.state.contentList.length >= max_len){
      // pop up error message
      this.props.root.addNotification(Localization.strings.EXCEED_MAX_COMPONENT, false);
    }else{
      this.setState({ currentContentIndex: -1 });
      this.state.currentContentIndex = -1;
      this.refs.createContentDialog.changeActiveStep(0);
      this.refs.createContentDialog.setState({ open: true });
    }
  }

  handleContentClicked(index) {
    this.setState({ currentContentIndex: index });
    this.state.currentContentIndex = index;
    this.refs.editContentDialog.setState({ open: true });
  }

  refreshContentList() {
    this.getContentByHotspotID(this.props.currentHotspot.id);
  }

  updateContentDisplayIndexOK(res){
    console.log('OK:', res);
  }

  updateContentDisplayIndexFail(err){
    console.log('update content display index failed');
  }

  updateContentDisplayIndex(){
    var pairs = [];
    console.log('content list:', this.state.contentList);
    for(let i = 0; i < this.state.contentList.length; i++){
      console.log('component_id:', this.state.contentList[i].id);
      console.log('component_dIndex:', this.state.contentList[i].display_index);
      pairs.push({component_id:this.state.contentList[i].id, component_dIndex:this.state.contentList[i].display_index});
    }
    let requestObj = {
      data:pairs
    };
    this.props.root.refs.API.request("set_components_display_index", requestObj, this.updateContentDisplayIndexOK, this.updateContentDisplayIndexFail);
  }

  swapContentDisplayIndexOK(res) {
    this.refreshContentList();
  }

  swapContentDisplayIndexFail(err) {
    console.log("move content fail " + err);
  }

  moveUpContentClicked(index) {
    let requestObj = {
      table: "component",
      component_id_1: this.state.contentList[index].id,
      component_id_2: this.state.contentList[index-1].id,
    }
    this.props.root.refs.API.request("swap_components_display_index", requestObj, this.swapContentDisplayIndexOK, this.swapContentDisplayIndexFail);
  }

  moveDownContentClicked(index) {
    let requestObj = {
      table: "component",
      component_id_1: this.state.contentList[index].id,
      component_id_2: this.state.contentList[index+1].id,
    }
    this.props.root.refs.API.request("swap_components_display_index", requestObj, this.swapContentDisplayIndexOK, this.swapContentDisplayIndexFail);
  }

  deleteContentClicked(id) {
    this.setState({ contentID: id });
    this.state.contentID = id;
    let dialogText = {
      title: Localization.strings.DELETE_CONTENT,
      content: Localization.strings.DELETE_REMINDER,
      confirm: Localization.strings.DELETE,
    }
    this.props.root.refs.confirmDialog.show(dialogText, this.deleteContentConfirmClicked, this.deleteContentCancelClicked);
  }

  deleteContentConfirmClicked() {
    if (this.state.contentID >= 0) {
      let requestObj = {table:"component", filter: {id: this.state.contentID}};
      this.props.root.refs.API.request("delete", requestObj, this.deleteContentOK, this.deleteContentFail);
    }
    this.setState({ contentID: -1 });
    this.state.contentID = -1;
  }

  deleteContentCancelClicked() {
    this.setState({ contentID: -1 });
    this.state.contentID = -1;
  }

  deleteContentOK(res) {
    this.refreshContentList();

    var requestObj = {epack_id: this.props.root.getCurrentLocale().id};
    this.props.root.refs.API.request("touch_epack", requestObj);
  }

  deleteContentFail(err) {
    console.log("delete content fail " + err);
  }

  getCurrentContent() {
    if (this.state.currentContentIndex < 0) {
      return null;
    }
    else {
      return this.state.contentList[this.state.currentContentIndex];
    }
  }

  onDragEnd(result) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const contentList = reorder(
      this.state.contentList,
      result.source.index,
      result.destination.index
    );

    this.setState({
      contentList
    });

    this.updateContentDisplayIndex();
  }

  render() {
    let unpositioned = this.props.currentHotspot['lat'] == "0" && this.props.currentHotspot["lon"] == "0";
      return (
        <div className="margin-std padding-std">
          <CreateContentDialog root={this.props.root} parent={this} ref="createContentDialog"/>
          <EditContentDialog root={this.props.root} parent={this} ref="editContentDialog"/>

          <Card>
            <CardContent>
                  <Grid container spacing={2} alignItems="center">
                    <Grid item xs={12} sm={3}>
                      {Localization.strings.NAME}
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <TextField className="width-full"
                        margin="normal"
                        size="small"
                        variant="outlined"
                        value={this.state.hotspotName}
                        onChange={this.hotspotNameChanged}
                        inputProps={{ maxLength: Config.MAX_TEXT_LEN().NAME }}
                      />
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      {Localization.strings.POSITION}
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <If condition={unpositioned}>
                        <Then>
                          <Button
                            color="primary"
                            onClick={this.props.parent.setHotspotPosition}
                          >
                            <Icon className="buttonIconLeft">my_location</Icon>
                            {Localization.strings.SET_POSITION}
                          </Button>
                        </Then>
                        <Else>
                          <TextField className="width-full text-sm"
                            margin="normal"
                            size="small"
                            variant="outlined"                          
                            label={Localization.strings.LATITUDE}
                            value={this.props.currentHotspot.lat}
                            disabled
                            InputProps={{ readOnly: true }}
                          />
                          <TextField className="width-full text-sm"
                            margin="normal"
                            size="small"
                            variant="outlined"
                            label={Localization.strings.LONGITUDE}
                            value={this.props.currentHotspot.lon}
                            disabled
                            InputProps={{ readOnly: true }}
                          />
                        </Else>
                      </If>
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      {Localization.strings.COLOR}
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <ExpansionPanel disabled={unpositioned} variant="outlined" className="padding-sm margin-zero">
                        <ExpansionPanelSummary expandIcon={<Icon>keyboard_arrow_down</Icon>} className="padding-sm margin-zero">
                          <Icon style={{ color: this.state.hotspotColor }} className="margin-zero">room</Icon>
                        </ExpansionPanelSummary>
                        <ExpansionPanelDetails className="padding-sm">
                          <CirclePicker
                            color={this.state.hotspotColor}
                            width="100%"
                            onChange={this.hotspotColorChanged}
                          />
                        </ExpansionPanelDetails>
                      </ExpansionPanel>
                    </Grid>

                    <Grid item xs={12} sm={3}>
                      {Localization.strings.RADIUS}
                    </Grid>

                    <Grid item xs={12} sm={7}>
                      <Slider
                        disabled={unpositioned}
                        value={this.state.hotspotRadius}
                        onChange={this.hotspotRadiusChanged}
                        onChangeCommitted={this.setHotspotRadius}
                        min={10}
                        max={100}
                        step={5}
                        style={{margin:'auto'}}
                      />
                    </Grid>
                    <Grid item xs={12} sm={2}>
                      {this.state.hotspotRadius} {Localization.strings.METER}
                    </Grid>


                    <Grid item xs={12} sm={3}>
                      {Localization.strings.HOTSPOT_VISIBILITY}
                    </Grid>
                    <Grid item xs={12} sm={9}>
                      <FormControl>
                        <Select
                          disabled={unpositioned}
                          value={this.state.hotspotVisibility}
                          onChange={this.hotspotVisibilityChanged}
                        >
                          <MenuItem value={1}>{Localization.strings.HOTSPOT_VISIBLE}</MenuItem>
                          <MenuItem value={0}>{Localization.strings.HOTSPOT_INVISIBLE}</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>

            <Grid item xs={12}>
              <Divider/>
            </Grid>
            <Button
            color="primary"
            variant="contained"
            className="margin-sm"
            style={{left:"15px"}}
            onClick={this.props.parent.addContentClicked}
          >

            <Icon className="buttonIconLeft">add</Icon>
            {Localization.strings.ADD_CONTENT}
          </Button>
            <div ref="visibilityDiv"/>

            <Grid item xs={12} style={{padding:'0'}}>
              <List style={{ height:this.state.contentListHeight, overflow:"auto", padding:"0" }}>
                <If condition={this.state.contentList.length > 0}>
                  <Then>
                    <DndProvider options={HTML5toTouch}>
                      <DragDropContext onDragEnd={this.onDragEnd}>
                        <Droppable droppableId="droppable">
                          {(provided, snapshot) => (
                          <RootRef rootRef={provided.innerRef}>
                            <List style={getListStyle(snapshot.isDraggingOver)}>
                            {this.state.contentList.map((row, i) => (
                              <Draggable key={row.id} draggableId={row.id} index={i}>
                                {(provided, snapshot) => (
                                <ListItem button onClick={()=>this.handleContentClicked(i)}
                                ContainerComponent="li"
                                ContainerProps={{ ref: provided.innerRef }}
                                {...provided.droppableProps}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style,
                                )}
                                >
                                  <ListItemIcon>
                                    <Icon>{Config.GET_HOTSPOT_CONTENT_CONFIG(row['kind']).icon}</Icon>
                                  </ListItemIcon>
                                    <div style={{width:"30%"}}>
                                  <ListItemText style={{ wordWrap: "break-word"}}>{row['name'] == ""? Config.GET_HOTSPOT_CONTENT_CONFIG(row['kind']).title : row['name']}</ListItemText>
                                    </div>
                                    <ListItemSecondaryAction>
                                      <If condition={i > 0}>
                                        <Then>
                                          <Tooltip title={Localization.strings.MOVE_UP}>
                                            <IconButton
                                            onClick={()=>this.moveUpContentClicked(i)}>
                                              <Icon style={{ color:snapshot.isDragging?"transparent":grey[400]}}>arrow_upward</Icon>
                                            </IconButton>
                                          </Tooltip>
                                        </Then>
                                      </If>
                                      <If condition={i < this.state.contentList.length-1}>
                                        <Then>
                                          <Tooltip title={Localization.strings.MOVE_DOWN}>
                                            <IconButton
                                            onClick={()=>this.moveDownContentClicked(i)}>
                                              <Icon style={{ color:snapshot.isDragging?"transparent" :grey[400]}}>arrow_downward</Icon>
                                            </IconButton>
                                          </Tooltip>
                                        </Then>
                                      </If>
                                      <Tooltip title={Localization.strings.DELETE}>
                                        <IconButton
                                        onClick={()=>this.deleteContentClicked(row['id'])}>
                                          <Icon style={{ color:snapshot.isDragging?"transparent" :grey[400]}}>delete</Icon>
                                        </IconButton>
                                      </Tooltip>
                                    </ListItemSecondaryAction>
                                    {provided.placeholder}
                                  </ListItem>                                  
                                  )}
                              </Draggable>
                              ))}
                                </List>
                              </RootRef>
                            )}
                            </Droppable>
                          </DragDropContext>
                        </DndProvider>
                  </Then>

                  <Else>
                      <img style={{display:'block',marginLeft:'auto',marginRight:'auto',top:'5%',height:'60px',width:'auto'}} src={Docuement} />
                    <Card style={{textAlign:'center'}}>
                      <CardContent>
                        {Localization.strings.EMPTY_CONTENT_REMINDER}
                      </CardContent>
                    </Card>
                  </Else>
                </If>
              </List>
            </Grid>
          </Grid>

          </CardContent>
        </Card>


        </div>
      )
  }
}

export default HotspotDetailView;
